export const BUTTON_CIRCLE_ACTIONS_TO_FONTAWESOME_ICON = Object.freeze({
  close: ['far', 'xmark'],
  ellipsis: ['far', 'ellipsis'],
  expand: ['far', 'list'],
  pin: ['far', 'thumbtack'],
  add: ['far', 'circle-plus'],
});

export const BUTTON_LIGHT_ACTIONS_TO_FONTAWESOME_ICON = Object.freeze({
  create: 'plus',
});

export const BUTTON_LINK_ACTIONS_TO_FONTAWESOME_ICON = Object.freeze({
  other_page: 'forward',
});

export const BUTTON_SECONDARY_ACTIONS_TO_FONTAWESOME_ICON = Object.freeze({
  arrow_down: 'arrow-down',
  arrow_up: 'arrow-up',
  create: 'plus',
  download: 'download',
  downloading: 'spinner',
  edit: 'pen-to-square',
  preview: ['far', 'eye'],
  save: 'save',
  unpublish: ['far', 'eye-slash'],
  upload: 'upload',
  unlock: ['far', 'unlock'],
  share: 'share',
  template: ['far', 'memo'],
  new: 'plus',
  info: ['far', 'circle-info'],
  lock: ['far', 'lock'],
  settings: ['far', 'gear'],
  reset: ['far', 'rotate-left'],
});
